module.exports = __webpack_public_path__ + "static/Lato-Semibold-c2b50f4a7d908c8d06f5b05ec135e166.woff";